module.exports = __webpack_public_path__ + "media/logos/wsj-logo-black-a20092ad.png";